module.exports = __webpack_public_path__ + "img/poisson.f951ce7a.svg";